import type { Entity } from '@backstage/catalog-model';

export const or =
  (...filters: readonly ((e: Entity) => boolean)[]) =>
    (e: Entity) =>
      filters.some(filter => filter(e));

export const and =
  (...filters: readonly ((e: Entity) => boolean)[]) =>
    (e: Entity) =>
      filters.every(filter => filter(e));

export const not = (filter: (e: Entity) => boolean) => (e: Entity) =>
  !filter(e);
